import Obfuscate from "react-obfuscate";

const ContactPage = () => {
  return (
    <div id="legal-main">
      <div>
        <span className="business-name">The Back Room&#8482; &amp; The Grow Shop</span> can
        be contacted at:
        <table>
          <tr>
            <th>Phone:</th>
            <td>
              <Obfuscate tel="(902) 530-0420" />
            </td>
          </tr>
          <tr>
            <th>Email:</th>
            <td>
              <Obfuscate email="info@thebackroom.ca" />
            </td>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <td></td>
          </tr>
          <tr>
            <th>Street:</th>
            <td>599 King St #102</td>
          </tr>
          <tr>
            <th>City/Province:</th>
            <td>Bridgewater, Nova Scotia</td>
          </tr>
          <tr>
            <th>Country:</th>
            <td>Canada</td>
          </tr>
          <tr>
            <th>Postal Code:</th>
            <td>B4V 1B3</td>
          </tr>
        </table>
      </div>

      <div></div>
    </div>
  );
};

export default ContactPage;
